const state= {
    Items:{
        items:[],
        total:0,
    }
};

const getters = {
    Items : (state) => state.Items,
};


const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/operating-hour`, {params:params})
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/operating-hour`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, data){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/operating-hour/${data.id}`, data)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, ids){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/operating-hour`, {
                data:{
                    ids: ids
                }
            })
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

}

const mutations = {
    setItems (state, data) {
        state.Items = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
